// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'
import VueTouch from 'vue-touch'


Vue.use(element)
Vue.use(VueTouch,{name:'v-touch'})

import SlidePage from './components/SlidePage.vue';
import eventBus from "../../../../../../util/eventBus";
import {utils} from "./common/common";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            // updateHtml(this.model, props)
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.invoke = (eventName, args)=>{
                invoke(eventName, args)
            }
            new Vue({
                el: model.dom,
                template: '<SlidePage :invoke="invoke"  :themeNum="themeNum" :lang="lang" :billTypes="billTypes"  :model="model" :KDApi="KDApi"/>',
                components: {
                    SlidePage
                },
                data: {
                    model: model,
                    KDApi: KDApi,
                    themeNum:"#5582F3",
                    lang:"zh_CN",
                    billTypes:[],
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    // this.dataInit()
                    if(props.themeNum){this.themeNum = props.themeNum;}
                    if(props.lang){this.lang = props.lang;}
                    this.billTypes = props.data.billTypes;

                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        console.log("props:"+props)
                        if(props.themeNum){this.themeNum = props.themeNum;}
                        this.billTypes = props.data.billTypes;
                    })
                },
                methods: {
                    dataInit(){
                        this.billTypes=[{'id':'A','name':'测试A'},{'id':'B','name':'测试B'},{'id':'C','name':'测试C'},{'id':'D','name':'测试D'}];
                    },
                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('slidePage', MyComponent,{
        isMulLang: true
    })
})(window.KDApi)
